import { render, staticRenderFns } from "./product_images.vue?vue&type=template&id=5318d941&scoped=true&"
import script from "./product_images.vue?vue&type=script&lang=js&"
export * from "./product_images.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5318d941",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5318d941')) {
      api.createRecord('5318d941', component.options)
    } else {
      api.reload('5318d941', component.options)
    }
    module.hot.accept("./product_images.vue?vue&type=template&id=5318d941&scoped=true&", function () {
      api.rerender('5318d941', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/tabs/product_images.vue"
export default component.exports